import Layers from "slotworks/graphics/layers/layers";
import loader from "slotworks/loader/loader";
import Contract from "slotworks/utils/contracts/contract";

export function RequireStageLoadCommand(stage: number, loadingPromptScene: string = "loading") {
    return new Contract<void>((resolve) => {
        Layers.Prompts.setScene(loadingPromptScene).execute();
        loader.loadStage(stage).then(() => {
            Layers.Prompts.defaultScene().execute();
            resolve();
        });
    });
}
